import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { useAuth } from "./context/AuthContext";
import { TaskFeedProvider } from "./context/TaskFeedContext";
import { AccountsPage } from "./pages/AccountsPage";
import { CreditsPage } from "./pages/CreditsPage";
import { IntegrationsPage } from "./pages/IntegrationsPage";
import { LoginPage } from "./pages/LoginPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { OverviewPage } from "./pages/OverviewPage";
import { TaskDetailPage } from "./pages/TaskDetailPage";
import { TasksPage } from "./pages/TasksPage";
import { AdminCodesPage } from "./pages/admin/AdminCodesPage";
import { AdminDiagnosticsPage } from "./pages/admin/AdminDiagnosticsPage";
import { AdminLayout } from "./pages/admin/AdminLayout";
import { AdminOverviewPage } from "./pages/admin/AdminOverviewPage";
import { AdminTasksPage } from "./pages/admin/AdminTasksPage";
import { AdminUsersPage } from "./pages/admin/AdminUsersPage";

function AppLoading() {
  return (
    <div className="app-loading" role="status" aria-live="polite">
      <span className="brand-mark brand-mark--large"><span /></span>
      <p>正在恢复工作空间</p>
    </div>
  );
}

function ProtectedLayout() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "loading") return <AppLoading />;
  if (status !== "authenticated") return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (location.pathname.startsWith("/admin")) return <AppShell />;
  return (
    <TaskFeedProvider>
      <AppShell />
    </TaskFeedProvider>
  );
}

function AdminGuard() {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/overview" replace />;
  return <Outlet />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedLayout />}>
        <Route index element={<Navigate to="/overview" replace />} />
        <Route path="/overview" element={<OverviewPage />} />
        <Route path="/accounts" element={<AccountsPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/tasks/:taskId" element={<TaskDetailPage />} />
        <Route path="/integrations" element={<IntegrationsPage />} />
        <Route path="/credits" element={<CreditsPage />} />
        <Route element={<AdminGuard />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<AdminOverviewPage />} />
            <Route path="users" element={<AdminUsersPage />} />
            <Route path="codes" element={<AdminCodesPage />} />
            <Route path="tasks" element={<AdminTasksPage />} />
            <Route path="diagnostics" element={<AdminDiagnosticsPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
